import { render, staticRenderFns } from "./left2.vue?vue&type=template&id=670e4998&scoped=true"
import script from "./left2.vue?vue&type=script&lang=js"
export * from "./left2.vue?vue&type=script&lang=js"
import style0 from "./left2.vue?vue&type=style&index=0&id=670e4998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e4998",
  null
  
)

export default component.exports